import { InfoTooltipIcon } from "./InfoTooltipIcon"

export const RatersInfoTooltipIcon = () => {
  return <InfoTooltipIcon label="Kontrollørene gjennomfører bærekraftmålingen for kunden(e). " />
}
